import axios from "axios";

export function getTundraCompensation(uuid) {
  return (dispatch) => {
    return axios.get("/compensation/" + uuid + "/public");
  };
}
